import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const BillingService = {
  getConversations: (
    account_id: number,
    init_date: string,
    end_date: string
  ) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}stadistics/billing/get-conversations`,
      { params: { account_id, init_date, end_date } }
    );
  },
  getTargets: (account_id: number, init_date: string, end_date: string) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}stadistics/billing/get-tarjets`,
      { params: { account_id, init_date, end_date } }
    );
  },
  getResume: (
    account_id: number,
    init_date: string,
    end_date: string,
    app: string
  ) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}stadistics/billing/get-resume-databases`,
      { params: { account_id, init_date, end_date, app } }
    );
  },
  getSendTemplates: (
    account_id: number,
    init_date: string,
    end_date: string,
    app: string
  ) => {
    return HTTP.get<any, any>(
      `${API_ENDPOINT.CORE}stadistics/billing/get-tarjets`,
      { params: { account_id, init_date, end_date, app } }
    );
  },
};
